import { isToday } from 'date-fns';

import { getRoundedPercentageOfValue, getRoundedValueOfPercentage } from '@sg/garnish';

import { getMaxTipAmount } from '../utils/tipping';
import { adjustWantedTime } from '../utils/wantedTimes';
import { type OrderingContext } from './ordering-machine.context';
import { type OrderingLedger, type WantedTime } from './ordering-machine.types';

export const isWantedTimeToday = (time?: WantedTime) => {
  const validTime = adjustWantedTime(time);

  return Boolean(validTime && isToday(validTime));
};

export const getNewTip = (
  previousTip: number,
  previousMaxTipAmount: number,
  availableTips: ReadonlyArray<number | 'CUSTOM'>,
  newLedger?: OrderingLedger,
): number => {
  const previousPercentage = getRoundedPercentageOfValue(previousTip, previousMaxTipAmount);

  if (availableTips.includes(previousPercentage)) {
    const newMaximumTip = getMaxTipAmount(newLedger);
    return getRoundedValueOfPercentage(previousPercentage, newMaximumTip) || 0;
  }

  const newMaximumTip = getMaxTipAmount(newLedger);
  if (previousTip > newMaximumTip) {
    return newMaximumTip;
  }

  return previousTip;
};

export function getMaxAvailableUpsellItems(params: GetMaxAvailableUpsellItemsParams) {
  const { lineItems, maxNumberOfUpsellProducts, upsellItems } = params;

  const cartProductIds = new Set(lineItems.map((lineItem) => lineItem.product?.id));
  const productsNotInCart = upsellItems.filter((item) => !cartProductIds.has(item.id));

  return productsNotInCart.slice(0, maxNumberOfUpsellProducts);
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GetMaxAvailableUpsellItemsParams = {
  lineItems: OrderingContext['cart']['lineItems'];
  upsellItems: OrderingContext['upsellItems'];
  maxNumberOfUpsellProducts: OrderingContext['maxNumberOfUpsellProducts'];
};
